// Newest year first. Add new events at the top of their year.
export const EVENTS = [
  {
    year: '2026',
    events: [
      'SFU Surge StormHacks, reward track and judges October 2026',
      'ESA CubeSat Support Facility testing, Belgium June 2026'
    ]
  },
  {
    year: '2025',
    events: [
      'Abbotsford International Airshow August 2025',
      'Darkvision Challenge May 2025'
    ]
  },
  {
    year: '2024',
    events: [
      'ESA\'s Fly Your Satellite April 2024',
      'SFU CS Industry Day April 2024',
      'ESA\'s Fly Your Satellite February 2024',
      'Star Wars for Kids by Vancouver Symphony Orchestra February 2024'
    ]
  },
  {
    year: '2023',
    events: [
      'Gifts of the Cosmos Orchestra November 2023'
    ]
  },
  {
    year: '2020',
    events: [
      'SFU SEE Building Visit by Lieutenant Governor and Governor General February 2020',
      'SFU Aerospace Info Session February 2020',
      'Women in STEM Conference February 2020',
      'McMillan Cosmic Night January 2020'
    ]
  },
  {
    year: '2019',
    events: [
      'McMillan Cosmic Night November 2019',
      'Science World Girls and STEAM November 2019',
      'Science Spooktacular October 2019',
      'SFU Aerospace Info Session September 2019',
      'FAS Welcome Days September 2019',
      'SFU Aerospace Showcase July 2019',
      'Victory Square Girls Camp July 2019',
      'Science Rendezvous & International Day of Astronomy May 2019',
      'McMillan Cosmic Night May 2019',
      'McMillan Cosmic Night January 2019'
    ]
  },
  {
    year: '2018',
    events: [
      'Technovation App Inventor Session November 2018',
      'Science World Girls and STEAM November 2018',
      'Science Spooktacular October 2018',
      'SFU Aerospace Info Session September 2018',
      'McMillan Cosmic Night Fall 2018',
      'Victory Square Girls Camp July 2018',
      'Stick\'in Stars/ Girls in Action July 2018',
      'Try / Catch June 2018',
      'Science Rendezvous & International Day of Astronomy May 2018',
      'Girls Get IT May 2018',
      'Go CODE Girl May 2018',
      'Young Western Canadian Entrepreneurs May 2018',
      'McMillan Cosmic Night Summer 2018',
      'Burnaby Festival of Learning Summer 2018',
      'McMillan Space Centre Weekend Event Summer 2018'
    ]
  },
  {
    year: '2017',
    events: [
      'Science Spooktacular October 2017',
      'Middle School Visit October 2017',
      'MSE FROSH September 2017',
      'Science Rendezvous & International Day of Astronomy April 2017',
      'Girls Get IT March 2017',
      'BC Tech Talks February 2017'
    ]
  },
  {
    year: '2016',
    events: [
      'CleanTech Demo November 2016',
      'SheTalks November 2016',
      'Go Eng Girl October 2016',
      'SD43 Presentation October 2016',
      'Perseid Meteor Shower Comet Demo August 2016',
      'Space Lecture Series February 2016'
    ]
  }
];
